module.exports = __webpack_public_path__ + "static/media/LAZ_01.d343adb5.jpg";